import { signalStore } from '@ngrx/signals';
import { withPromotionEntity } from './features/withPromotionEntity';
import { withPromotionItems } from './features/withPromotionItems';

export const PromotionComponentStore = signalStore(withPromotionEntity(), withPromotionItems());

export type PromotionComponentStore = InstanceType<typeof PromotionComponentStore>;
